// Which half of the picture a GPA typed into a bare "what's your GPA?" ask
// lands in (#5240, founder rule 2026-10-23): 4.0 or below is unweighted,
// above 4.0 weighted. The server's rule is gpa_scale.py (counselor_agent and
// profile_manager_v2); this number is pinned to its UNWEIGHTED_MAX by
// tests/test_gpa_scale_drift.py.
export const UNWEIGHTED_MAX = 4.0;

export function gpaField(value) {
    return Number(value) > UNWEIGHTED_MAX ? 'gpa_weighted' : 'gpa_unweighted';
}
